import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import type { RecoverableSession } from '../utils/assessmentSessionRecovery';
import { useFocusTrap } from '../../app/hooks/useFocusTrap';
import { useEscapeKey } from '../../app/hooks/useEscapeKey';
interface AssessmentRecoveryModalProps {
  session: RecoverableSession;
  onResume: () => void;
  onAbandon: () => void;
}
export function AssessmentRecoveryModal({
  session,
  onResume,
  onAbandon
}: AssessmentRecoveryModalProps) {
  const focusTrapRef = useFocusTrap(true);
  useEscapeKey(onAbandon);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" data-id="element-840" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-841">
        <div ref={focusTrapRef} className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 space-y-4" role="dialog" aria-modal="true" aria-labelledby="recovery-title" data-id="element-842">
          <div className="flex items-center gap-3" data-id="element-843">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center" data-id="element-844">
              <AlertCircle className="h-5 w-5 text-amber-600" data-id="element-845" />
            </div>
            <div data-id="element-846">
              <h2 id="recovery-title" className="text-lg font-bold text-gray-900" data-id="element-847">
                Toets hervatten?
              </h2>
              <p className="text-sm text-gray-500" data-id="element-848">
                Er is een onafgemaakte toets gevonden
              </p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-3 space-y-1" data-id="element-849">
            <p className="text-sm text-gray-700" data-id="element-850">
              <strong data-id="element-851">{session.attempt.answers.length}</strong> van{' '}
              <strong data-id="element-852">{session.blueprint.questions.length}</strong> vragen
              beantwoord
            </p>
            <p className="text-xs text-gray-500" data-id="element-853">
              Opgeslagen {Math.round((Date.now() - session.savedAt) / 60000)}{' '}
              minuten geleden
            </p>
          </div>

          <div className="flex gap-3" data-id="element-854">
            <Button variant="secondary" onClick={onAbandon} className="flex-1" data-id="element-855">
              Opnieuw beginnen
            </Button>
            <Button variant="primary" onClick={onResume} className="flex-1" data-id="element-856">
              Hervatten
            </Button>
          </div>
        </div>
      </div>
    </>;
}